export default {
	'add-message': 'Add Message',
	'edit-message': 'Edit Message',
	'send-message': 'Send message'
}